<template>
  <div>
    <div v-if="searchField || filterCount">
      <v-row
        v-if="$vuetify.breakpoint.smAndUp"
        :class="isSticky"
        v-intersect="onIntersect"
      >
        <v-col
          v-if="searchField"
          cols="12"
          sm="6"
          :md="fullScreen ? '4' : false"
        >
          <BaseListSearch
            :ref="`search-${type}`"
            :disableSearch="!searchTerm"
            :value="searchTerm"
            @input="search"
            @keydown="checkInput"
            @click:clear="resetSearch"
            @doSearch="$emit('doSearch')"
          />
        </v-col>
        <v-col
          v-for="i in filterCount"
          :key="i"
          cols="12"
          sm="6"
          :md="fullScreen ? '4' : false"
        >
          <slot :name="`filter${i}`"></slot>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-else
        accordion
        class="filter-panel pb-3"
        :value="searchTerm || isFiltered ? 0 : null"
        ><v-expansion-panel>
          <v-expansion-panel-header :color="filterPanelStyle">
            {{ $t('invoice.filter') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content :color="filterPanelStyle">
            <v-row>
              <v-col cols="12">
                <BaseListSearch
                  :ref="`search-${type}`"
                  :disableSearch="!searchTerm"
                  :value="searchTerm"
                  @input="search"
                  @keydown="checkInput"
                  @click:clear="resetSearch"
                  @doSearch="$emit('doSearch')"
                />
              </v-col>
              <v-col cols="12" v-for="i in filterCount" :key="i">
                <slot :name="`filter${i}`"></slot>
              </v-col>
            </v-row>
          </v-expansion-panel-content> </v-expansion-panel
      ></v-expansion-panels>
    </div>
    <!-- <v-pagination
      v-if="pagination && !noData && $vuetify.breakpoint.smAndUp"
      ref="topPagination"
      :value="page"
      :length="totalPages"
      total-visible="10"
      @input="changePage"
    /> -->
    <slot></slot>
    <div v-if="isLoading" class="list-loader">
      <Loading
        :active.sync="showLoading"
        :is-full-page="false"
        :z-index="2"
        loader="dots"
      ></Loading>
    </div>
    <div :hidden="!noData" class="text-h6 text-center my-6">
      {{ $t(noDataText) }}
    </div>
    <v-pagination
      v-if="pagination && !noData"
      :value="page"
      :length="totalPages"
      total-visible="10"
      @input="changePage"
    />
    <v-btn
      v-if="showUp && !isIntersecting"
      fixed
      color="primary"
      fab
      bottom
      right
      @click.stop="$helper.scrollTop"
      ><v-icon :size="32">$up</v-icon></v-btn
    >
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import scrollIntoView from 'smooth-scroll-into-view-if-needed'
import debounce from 'lodash/debounce'

export default {
  name: 'BaseList',

  props: {
    searchTerm: String,
    page: Number,
    totalPages: Number,
    noData: Boolean,
    noDataText: String,
    searchField: {
      type: Boolean,
      default: true
    },
    filterCount: Number,
    isFiltered: Boolean,
    fullScreen: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Boolean,
      default: true
    },
    type: String,
    isLoading: Boolean
  },

  components: {
    Loading
  },

  data: () => ({
    isIntersecting: true,
    showLoading: false
  }),

  computed: {
    isSticky() {
      if (this.fullScreen && !this.filterCount) {
        if (this.type === 'dish') {
          return 'sticky-el--menu'
        } else {
          return 'sticky-el--submenu'
        }
      }
      return ''
    },

    showUp() {
      return this.fullScreen && this.filterCount
    },

    filterPanelStyle() {
      if (!this.searchTerm && !this.isFiltered) {
        return ''
      } else {
        return 'yellow'
      }
    }
  },

  mounted() {
    this.search = debounce(this.search, 500)
  },

  watch: {
    totalPages(val) {
      if (val < this.page) {
        this.$emit('update:page', val)
      }
    },

    isLoading: {
      immediate: true,
      handler: function (val) {
        this.showLoading = val
      }
    }
  },

  methods: {
    onIntersect(entries) {
      this.isIntersecting = entries[0].isIntersecting
    },

    search(payload) {
      this.$emit('update:searchTerm', payload)
    },

    changePage(payload) {
      this.$emit('update:page', payload)
      scrollIntoView(this.$refs[`search-${this.type}`].$el)
    },

    checkInput(e) {
      if (e.key === 'Enter') {
        this.$emit('doSearch')
        this.$refs[`search-${this.type}`].$refs.textInput.blur()
      }
    },

    resetSearch() {
      this.$emit('update:searchTerm', '')
      this.$emit('doSearch')
    }
  }
}
</script>

<style scoped></style>
